import { Component } from '../../types/Component';
import { ComponentSection, ComponentSectionsProgress, DefaultComponentSections } from '../../types';
import { getFilterFunction } from './getFilterFunction';
import { getSectionProgress } from './getSectionProgress';
import { getSectionProgressValues } from './getSectionProgressValues';
import { isNonElectricalComponentType } from 'src/models/data/non-electrical-components';

const getComponentProgress = (component: Component, sections = DefaultComponentSections): ComponentSectionsProgress => {
    const filteredSections = isNonElectricalComponentType(component.type)
        ? sections.filter((section) => section !== ComponentSection.ELECTRICAL)
        : sections;

    return Object.fromEntries(
        filteredSections.map((section): [ComponentSection, number] => [
            section,
            getSectionProgress(getSectionProgressValues(component, section), getFilterFunction(section)),
        ]),
    ) as ComponentSectionsProgress;
};

const averageComponentProgress = (progress: ComponentSectionsProgress): number => {
    const progressValues = Object.values(progress);

    return progressValues.reduce((sum, value) => sum + value) / progressValues.length;
};

export { getComponentProgress, averageComponentProgress };
